import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { NotificationService } from 'src/app/services/notification.service';
import { FormDto } from '../../model/form-dto';
import { FormFormuleService } from '../../service/form-formule.service';

@Component({
  selector: 'app-new-form',
  templateUrl: './new-form.component.html',
  styleUrls: ['./new-form.component.scss']
})
export class NewFormComponent implements OnInit {

  form: FormGroup;
  formDTO: FormDto = new FormDto();
  isEdit: boolean = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private notificationService: NotificationService,
    private service: FormFormuleService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.getUser();
    this.createForm();
    this.getForm();
  }

  createForm = () => {
    this.form = this.fb.group({
      id: [null],
      name: ['', Validators.required],
      description: ['']
    })
  }

  backList = () => {
    this.router.navigateByUrl('adm/form/list');
  }

  populateDTO = (): FormDto => {
    let obj = new FormDto();
    obj.id = this.form.controls.id.value;
    obj.name = this.form.controls.name.value;
    obj.description = this.form.controls.description.value;

    return obj;
  }

  populateForm = () => {    
    this.form.controls.id.setValue(Number(this.formDTO.id));
    this.form.controls.name.setValue(this.formDTO.name);
    this.form.controls.description.setValue(this.formDTO.description);
  }

  getForm = () => {
    let idForm = this.route.snapshot.params['id'];
    if (idForm !== undefined) {
      this.isEdit = true;
      this.formDTO.id = Number(idForm);

      this.service.getById(this.formDTO.id)
      .then(res => {
        this.formDTO = res[0];
        this.populateForm();
      })
      .catch(err => {
        console.error(err);        
      })

    } else {
      this.isEdit = false;
    }
  }

  saveUpdate = () => {
    if (this.isEdit) this.edit();
    else this.save();
  }

  edit = () => {
    if (this.form.invalid) {
      this.notificationService.sendNotification(
        null,
        TypeMessage.FormInvalid,
        ActionMessage.Info
      );
      return;
    }

    this.service.saveOrUpdate(this.populateDTO())
      .then(res => {
        this.notificationService.sendNotification(
          null,
          TypeMessage.Edit,
          ActionMessage.Success
        );
        this.backList();
      })
      .catch(err => {
        console.error(err);
      })

  }

  save = () => {
    if (this.form.invalid) {
      this.notificationService.sendNotification(
        null,
        TypeMessage.FormInvalid,
        ActionMessage.Info
      );
      return;
    }

    this.service.saveOrUpdate(this.populateDTO())
      .then(res => {
        this.notificationService.sendNotification(
          null,
          TypeMessage.New,
          ActionMessage.Success
        );
        this.goAddFormule(res.id);
      })
      .catch(err => {
        console.error(err);
      })

  }

  goAddFormule = (idForm) => {
    this.router.navigateByUrl('adm/form/new-formule/' + idForm);
  }

  getUser = () => {
    this.service.getUserCwid()
    .then(res => {
      if (res.length === 0) this.backList();
    })
    .catch(err => {
      console.error(err);      
    })
  }

}
